import { createContext, useContext } from "react";

export interface AuthContextType {
  address: `0x${string}` | undefined;
  isAuthenticated: boolean;
  isLoading: boolean;
  logout: () => void;
  hasCompletedOnboarding: boolean;
  reconnect: () => void;
  referrerFromUrl: string | null;
  authedViaLogin: boolean;
  role?: string;
}
export const AuthContext = createContext<AuthContextType | undefined>(undefined);

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    if (import.meta.env.PROD) throw new Error("useAuth must be used within an AuthProvider");
    console.warn(
      "No auth provider. This is a common side effect of HMR but is indicative of poor rendering optimization",
    );
    return {} as AuthContextType;
  }
  return context;
};
